import { render, staticRenderFns } from "./Onderwijskwaliteit.vue?vue&type=template&id=266ba0c2&scoped=true&"
import script from "./Onderwijskwaliteit.vue?vue&type=script&lang=js&"
export * from "./Onderwijskwaliteit.vue?vue&type=script&lang=js&"
import style0 from "./Onderwijskwaliteit.vue?vue&type=style&index=0&id=266ba0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ba0c2",
  null
  
)

export default component.exports